import React, { FC, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'
import urlParser from 'js-video-url-parser'

import { HOST_NAME } from '@data/config/url'

import { Metadata } from '../Metadata'

import { PresentationMetadata_presentation$key } from './__generated__/PresentationMetadata_presentation.graphql'

export const PresentationMetadata: FC<{
  presentation: PresentationMetadata_presentation$key
  title?: string
  description?: string
}> = ({
  presentation,
  title: overridenTitle,
  description: overridenDescription,
}) => {
  const {
    description,
    presenter,
    presenterFirstName,
    presenterLastName,
    title: presentationTitle,
    videoSourceUrl,
    prettyUrl,
    updatedAt,
  } = useFragment(
    graphql`
      fragment PresentationMetadata_presentation on Presentation {
        title
        description

        presenterFirstName
        presenterLastName

        videoSourceUrl
        prettyUrl

        updatedAt

        presenter {
          firstName
          lastName
          primaryPhoto {
            url
          }
        }
      }
    `,
    presentation
  )

  const photoUrl = useMemo(() => {
    if (videoSourceUrl) {
      const videoInfo = urlParser.parse(videoSourceUrl)

      if (videoInfo?.provider === 'youtube') {
        const photoUrl = urlParser.create({
          format: 'longImage',
          params: { imageQuality: 'maxresdefault' },
          videoInfo,
        })

        if (photoUrl) {
          return photoUrl
        }
      }
    }

    return `${HOST_NAME}/social/presentation/${prettyUrl}/card.png?${updatedAt}`
  }, [videoSourceUrl, prettyUrl, updatedAt])

  const name = presenter
    ? `${presenter.firstName} ${presenter.lastName}`
    : `${presenterFirstName} ${presenterLastName}`

  const title = overridenTitle || `${presentationTitle} by ${name}`

  return (
    <Metadata
      description={overridenDescription || description}
      imageKitParams='NONE'
      photoUrl={photoUrl}
      title={title}
    />
  )
}
